import React, { createContext, useState, useContext } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);

  // Data dummy user
  const dummyUsers = [
    { id: 1, email: 'admin@bumdes.id', password: 'password123', role: 'admin', name: 'Admin BUMDES' },
    { id: 2, email: 'bendahara@bumdes.id', password: 'password123', role: 'bendahara', name: 'Bendahara' },
    { id: 3, email: 'pengelola@bumdes.id', password: 'password123', role: 'pengelola', name: 'Pengelola Produk' }
  ];

  const login = async (email, password) => {
    setLoading(true);
    
    // Simulasi API call
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const foundUser = dummyUsers.find(
          user => user.email === email && user.password === password
        );
        
        if (foundUser) {
          const userData = { ...foundUser };
          delete userData.password; // Hapus password dari state
          setUser(userData);
          localStorage.setItem('bumdes_user', JSON.stringify(userData));
          resolve(userData);
        } else {
          reject(new Error('Email atau password salah'));
        }
        setLoading(false);
      }, 1500);
    });
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('bumdes_user');
  };

  // Check if user is logged in on app start
  React.useEffect(() => {
    const savedUser = localStorage.getItem('bumdes_user');
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
  }, []);

  const value = {
    user,
    login,
    logout,
    loading,
    isAuthenticated: !!user
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};